export default __webpack_public_path__ + "static/media/F.0a4e85a5.svg";